import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminLogin.css'; // crie um CSS bem simples, se quiser

const VALID_USER = 'admingoodata';          // <— Troque para o usuário que desejar
const VALID_PASS = 'goodata123';     // <— Troque para a senha que desejar
const AUTH_FLAG  = 'isAdminAuthenticated';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [user, setUser]       = useState('');
  const [pass, setPass]       = useState('');
  const [error, setError]     = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (user === VALID_USER && pass === VALID_PASS) {
      localStorage.setItem(AUTH_FLAG, 'true');
      navigate('/admin-chats');
    } else {
      setError('Usuário ou senha inválidos');
    }
  };

  return (
    <div className="admin-login-wrapper">
      <form className="admin-login-form" onSubmit={handleSubmit}>
        <h2>Login Administrativo</h2>
        <div className="field">
          <label>Usuário</label>
          <input
            type="text"
            value={user}
            onChange={e => setUser(e.target.value)}
            required
          />
        </div>
        <div className="field">
          <label>Senha</label>
          <input
            type="password"
            value={pass}
            onChange={e => setPass(e.target.value)}
            required
          />
        </div>
        {error && <div className="error">{error}</div>}
        <button type="submit">Entrar</button>
      </form>
    </div>
  );
}
